import { useEffect, useMemo, useState } from 'react'
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import { Button, Card, CardContent, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'

export default function MCProjectDetailPage() {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const [project, setProject] = useState(null)
  const [inputs, setInputs] = useState([])
  const [runs, setRuns] = useState([])

  useEffect(() => {
    materialCalculatorApi.getProject(projectId).then(setProject).catch(() => setProject(null))
    materialCalculatorApi.listInputs(projectId).then(setInputs).catch(() => setInputs([]))
    materialCalculatorApi.listRuns(projectId).then(setRuns).catch(() => setRuns([]))
  }, [projectId])

  const completedSections = useMemo(() => new Set(inputs.map((i) => i.sectionKey)).size, [inputs])

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Detalle de Proyecto</h1>
        <div className="flex gap-2">
          <Button onClick={() => navigate(`/material-calculator/projects/${projectId}/wizard`)}>Abrir asistente</Button>
          <Button variant="outline" onClick={() => navigate(`/material-calculator/projects/${projectId}/reports`)}>Ver Reportes</Button>
        </div>
      </div>

      <div className="flex gap-2 text-sm">
        {['resumen', 'inputs', 'takeoff', 'reportes', 'versiones'].map((t) => <span className="rounded bg-gray-100 px-2 py-1" key={t}>{t}</span>)}
      </div>

      <Card>
        <CardHeader><CardTitle>{project?.name || 'Proyecto'}</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
          <div className="rounded border p-3">País: <strong>{project?.countryCode || '-'}</strong></div>
          <div className="rounded border p-3">Conjunto de reglas: <strong>{project?.rulesetId || '-'}</strong></div>
          <div className="rounded border p-3">Moneda: <strong>{project?.currencyCode || '-'}</strong></div>
          <div className="rounded border p-3">Capítulos completos: <strong>{completedSections}/6</strong></div>
          <div className="rounded border p-3">Última corrida: <strong>{project?.lastCalculatedAt ? new Date(project.lastCalculatedAt).toLocaleString() : '-'}</strong></div>
          <div className="rounded border p-3">Runs: <strong>{runs.length}</strong></div>
        </CardContent>
      </Card>

      <div className="text-sm text-gray-600">
        <NavLink className="text-primary-700 underline" to={`/material-calculator/projects/${projectId}/wizard`}>Ir al asistente</NavLink>
      </div>
    </div>
  )
}
